export default class Branding {
    constructor(readonly primaryColor: string, readonly backgroundColor: string) {}
}
